<template>
  <el-row class="container-card el-row">
    <el-row class="container-fluid"> </el-row>
    <div class="relative-wrapper">
      <div class="inner-wrapper">
        <div class="info">
          <div class="flex-center">
            <img
              v-if="artist_track && artist_track.image_url !== null"
              id="img"
              :src="artist_track.image_url"
            />
            <img
              v-else-if="
                artist_label !== null && artist_label.file_name !== null
              "
              class="avatar"
              :src="`${url}artists/${artist_label.file_name}`"
            />
            <img
              v-else-if="artist && artist.file_name !== null"
              class="avatar"
              :src="`${url}artists/${artist.file_name}`"
            />
            <img
              v-else
              class="avatar"
              src="https://app.syncvault.com/static/apple-touch-icon.png"
            />
          </div>
          <div class="details">
            <h2>Track Dashboard</h2>
            <p v-if="artist_track">
              {{ artist_track.title }} - {{ artist_track.artist_name }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <TrackDashboard />
  </el-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TrackDashboard from '@/modules/artist/dashboard/views/Index'

export default {
  components: {
    TrackDashboard
  },

  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL
    }
  },

  computed: {
    ...mapState('artistDashboard', ['artist_label']),
    ...mapState('auth', ['artist']),
    ...mapState('artistDashboard', ['artist_track'])
  },

  methods: {
    ...mapMutations('artistDashboard', ['setSelectedTrack'])
  }
}
</script>

<style lang="scss" scoped>

.container-fluid {
  height: 105px;
  margin: 0;
  top: -55px;
  border-radius: 7px;
  width: 100%;
  position: absolute;
  overflow: hidden;
  background: #fbfbfb;
}

.relative-wrapper {
  position: relative;
  padding: 0 10px;
  top: -49px;
  .inner-wrapper {
    .info {
      display: flex;
      #img {
        width: 90px;
        height: 90px;
        border-radius: 66px;
      }
    }
    .details {
      padding: 0 1rem;
      h2 {
        margin-bottom: 5px;
      }
      p {
        margin: 0.3rem 0 1.2rem;
        font-size: 16px;
      }
    }
  }
}

.dashboard {
  padding: 2rem 0;
}
</style>
